var exports = {
  "x": "x61f99309--1c9e7c--button",
};

module.exports = exports;
